import { ConstraintAreaTeamRigBase } from './base/constraint-area-team-rig-base';

export class ConstraintAreaTeamRig extends ConstraintAreaTeamRigBase { }